import { createReducer, on } from '@ngrx/store';
import { OpportunityFile } from '@/models/opportunity-file.model';
import * as OpportunityFilesActions from './opportunity-files.actions';

export interface OpportunityFilesState {
  files: OpportunityFile[];
  loading: boolean;
  error: any;
}

export const initialState: OpportunityFilesState = {
  files: [],
  loading: false,
  error: null,
};

export const opportunityFilesReducer = createReducer(
  initialState,

  // Load files actions
  on(OpportunityFilesActions.loadOpportunityFiles, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(OpportunityFilesActions.loadOpportunityFilesSuccess, (state, { files }) => ({
    ...state,
    files,
    loading: false,
    error: null,
  })),

  on(OpportunityFilesActions.loadOpportunityFilesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create file actions
  on(OpportunityFilesActions.createOpportunityFile, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(OpportunityFilesActions.createOpportunityFileSuccess, (state, { file }) => ({
    ...state,
    files: [...state.files, file],
    loading: false,
    error: null,
  })),

  on(OpportunityFilesActions.createOpportunityFileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update file actions
  on(OpportunityFilesActions.updateOpportunityFile, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(OpportunityFilesActions.updateOpportunityFileSuccess, (state, { file }) => ({
    ...state,
    files: state.files.map((f) => (f.id === file.id ? file : f)),
    loading: false,
    error: null,
  })),

  on(OpportunityFilesActions.updateOpportunityFileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Bulk update files actions
  on(OpportunityFilesActions.bulkUpdateOpportunityFiles, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(OpportunityFilesActions.bulkUpdateOpportunityFilesSuccess, (state, { files }) => ({
    ...state,
    files: state.files.map((existingFile) => {
      const updatedFile = files.find((f) => f.id === existingFile.id);
      return updatedFile || existingFile;
    }),
    loading: false,
    error: null,
  })),

  on(OpportunityFilesActions.bulkUpdateOpportunityFilesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete file actions
  on(OpportunityFilesActions.deleteOpportunityFile, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(OpportunityFilesActions.deleteOpportunityFileSuccess, (state, { file }) => ({
    ...state,
    files: state.files.filter((f) => f.id !== file.id),
    loading: false,
    error: null,
  })),

  on(OpportunityFilesActions.deleteOpportunityFileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update file category actions
  on(OpportunityFilesActions.updateOpportunityFileCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(OpportunityFilesActions.updateOpportunityFileCategorySuccess, (state, { file }) => ({
    ...state,
    files: state.files.map((f) => (f.id === file.id ? file : f)),
    loading: false,
    error: null,
  })),

  on(OpportunityFilesActions.updateOpportunityFileCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Clear files action
  on(OpportunityFilesActions.clearOpportunityFiles, (state) => ({
    ...state,
    files: [],
    loading: false,
    error: null,
  }))
);
